var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeCard"},[_c('img',{attrs:{"src":_vm.data.image,"alt":_vm.data.title}}),_c('div',{staticClass:"content"},[_c('h4',{staticClass:"mb-2 mt-2"},[_vm._v(_vm._s(_vm.data.title))]),_c('p',[_vm._v(_vm._s(_vm.data.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }